import { 
    MDBCol, 
    MDBContainer, 
    MDBRow,
    MDBCard,
    MDBCardBody,
    MDBCardTitle,
    MDBCardText, 
    MDBBtn} from "mdb-react-ui-kit";
import React , { useEffect, useState }from "react";
import Chart from 'chart.js/auto'
const Earthquake = () => {
    const [data3, setScene3] = useState([])
    const [data4, setScene4] = useState([])
    const [data5, setScene5] = useState([])
    const [data6, setScene6] = useState([])

    const [chart3, setChart3] = useState(null);
    const [chart4, setChart4] = useState(null);
    const [chart5, setChart5] = useState(null);
    const [chart6, setChart6] = useState(null);

    useEffect(()=>{
        fetch(`${process.env.REACT_APP_URL}disaster/find`)
        .then(result => result.json())
        .then(data => {
            const data3 = data.data.filter(l => l.scenario === "3")
            const data4 = data.data.filter(l => l.scenario === "4")
            const data5 = data.data.filter(l => l.scenario === "5")
            const data6 = data.data.filter(l => l.scenario === "6")
            setScene3(data3)
            setScene4(data4)
            setScene5(data5)
            setScene6(data6)
        })
       
    },[])

    useEffect(()=> {
      const choice = [
        "Scene 3 Choices"
      ]
      const choicemaleA = data3.filter(e => e.choice === 'a' && e.gender === 'male')
      const choicefemaleB = data3.filter(e => e.choice === 'b' && e.gender === 'female')

      const choicefemaleA = data3.filter(e => e.choice === 'a' && e.gender === 'female')
      const choicemaleB = data3.filter(e => e.choice === 'b' && e.gender === 'male')
      const scene3 = document.getElementById("scene3")
      if (scene3) {
          const existingChart = Chart.getChart(scene3);
          if (existingChart) {
              existingChart.destroy();
          }
          const newChart = new Chart(scene3, 
              {
                  type: 'bar',
                  data: {
                    labels: choice,
                    datasets: [
                      {
                        label: 'Choice A Male',
                        data: [choicemaleA.length]
                      },
                      {
                          label: 'Choice B Female',
                          data: [choicefemaleB.length]
                      },
                      {
                          label: 'Choice A Female',
                          data: [choicefemaleA.length]
                      },
                      {
                          label: 'Choice B Male',
                          data: [choicemaleB.length]
                      },
                    ]
                  }
                });
          setChart3(newChart);
      }
    },[data3])

    useEffect(()=>{
      const choice = [
        "Scene 4 Choices"
      ]
      const choicemaleA = data4.filter(e => e.choice === 'a' && e.gender === 'male')
      const choicefemaleB = data4.filter(e => e.choice === 'b' && e.gender === 'female')

      const choicefemaleA = data4.filter(e => e.choice === 'a' && e.gender === 'female')
      const choicemaleB = data4.filter(e => e.choice === 'b' && e.gender === 'male')
      const scene4 = document.getElementById("scene4")
      if (scene4) {
          const existingChart = Chart.getChart(scene4);
          if (existingChart) {
              existingChart.destroy();
          }
          const newChart = new Chart(scene4, 
              {
                  type: 'bar',
                  data: {
                    labels: choice,
                    datasets: [
                      {
                        label: 'Choice A Male',
                        data: [choicemaleA.length]
                      },
                      {
                          label: 'Choice B Female',
                          data: [choicefemaleB.length]
                      },
                      {
                          label: 'Choice A Female',
                          data: [choicefemaleA.length]
                      },
                      {
                          label: 'Choice B Male',
                          data: [choicemaleB.length]
                      },
                    ]
                  }
                });
          setChart4(newChart);
      }
    },[data4])

    useEffect(()=>{
      const choice = [
        "Scene 5 Choices"
      ]
      const choicemaleA = data5.filter(e => e.choice === 'a' && e.gender === 'male')
      const choicefemaleB = data5.filter(e => e.choice === 'b' && e.gender === 'female')

      const choicefemaleA = data5.filter(e => e.choice === 'a' && e.gender === 'female')
      const choicemaleB = data5.filter(e => e.choice === 'b' && e.gender === 'male')
      const scene5 = document.getElementById("scene5")
      if (scene5) {
          const existingChart = Chart.getChart(scene5);
          if (existingChart) {
              existingChart.destroy();
          }
          const newChart = new Chart(scene5, 
              {
                  type: 'bar',
                  data: {
                    labels: choice,
                    datasets: [
                      {
                        label: 'Choice A Male',
                        data: [choicemaleA.length]
                      },
                      {
                          label: 'Choice B Female',
                          data: [choicefemaleB.length]
                      },
                      {
                          label: 'Choice A Female',
                          data: [choicefemaleA.length]
                      },
                      {
                          label: 'Choice B Male',
                          data: [choicemaleB.length]
                      },
                    ]
                  }
                });
          setChart5(newChart);
      }
    },[data5])

    useEffect(()=>{
      const choice = [
        "Scene 6 Choices"
      ]
      const choicemaleA = data6.filter(e => e.choice === 'a' && e.gender === 'male')
      const choicefemaleB = data6.filter(e => e.choice === 'b' && e.gender === 'female')

      const choicefemaleA = data6.filter(e => e.choice === 'a' && e.gender === 'female')
      const choicemaleB = data6.filter(e => e.choice === 'b' && e.gender === 'male')
      const scene6 = document.getElementById("scene6")
      if (scene6) {
          const existingChart = Chart.getChart(scene6);
          if (existingChart) {
              existingChart.destroy();
          }
          const newChart = new Chart(scene6, 
              {
                  type: 'bar',
                  data: {
                    labels: choice,
                    datasets: [
                      {
                        label: 'Choice A Male',
                        data: [choicemaleA.length]
                      },
                      {
                          label: 'Choice B Female',
                          data: [choicefemaleB.length]
                      },
                      {
                          label: 'Choice A Female',
                          data: [choicefemaleA.length]
                      },
                      {
                          label: 'Choice B Male',
                          data: [choicemaleB.length]
                      },
                    ]
                  }
                });
          setChart6(newChart);
      }
    },[data6])
    const handlePrint = () => {
      window.print();
    };
    return(
        <MDBContainer>
            <MDBRow>
                <MDBCol className="mt-5">
                    <MDBBtn onClick={handlePrint}>
                        PRINT
                    </MDBBtn>
                </MDBCol>
            </MDBRow>
            <MDBContainer id="section-to-print">
            <MDBRow>
                <MDBCol>
                <MDBCard className="mt-5"> 
                <MDBCardBody>
                    <MDBCardTitle className="">Scene 3: Bodyguard Scene </MDBCardTitle>
                    <canvas id="scene3">

                    </canvas>
                    <MDBCardText>
                    Bodyguard: Hey kiddo, your teacher announced that classes are off today. There is an Earthquake Drill Seminar, do you want to join?
                    </MDBCardText>
                    <MDBCardText>
                    Choice A Yes sir! Thank you
                    </MDBCardText>
                    <MDBCardText>
                    {`Choice B: No, sir I guess I’ll Just go home. – Game Over (Happily went home)`}
                    </MDBCardText>
                </MDBCardBody>
                </MDBCard>
                </MDBCol>
            </MDBRow>
            <MDBRow>
                <MDBCol>
                <MDBCard className="mt-5"> 
                <MDBCardBody>
                    <MDBCardTitle className="">Scene 4: During Earthquake Scene </MDBCardTitle>
                    <canvas id="scene4">

                    </canvas>
                    <MDBCardText>
                    Narrator: you are near your classroom and you see your classmates trembling in fear underneath the tables. Should you
                    </MDBCardText>
                    <MDBCardText>
                    Choice A: Run to the exit 
                    </MDBCardText>
                    <MDBCardText>
                    Choice B: Get underneath the table in your classroom
                    </MDBCardText>
                </MDBCardBody>
                </MDBCard>
                </MDBCol>
            </MDBRow>
            <MDBRow>
                <MDBCol>
                <MDBCard className="mt-5"> 
                <MDBCardBody>
                    <MDBCardTitle className="">Scene 5: Post Earthquake Scene</MDBCardTitle>
                    <canvas id="scene5">

                    </canvas>
                    <MDBCardText>
                    Narrator: It was almost half an hour; you check the surroundings and feel safe. Your teacher also signals you to go outside. Should you
                    </MDBCardText>
                    <MDBCardText>
                    Choice A: Stay
                    </MDBCardText>
                    <MDBCardText>
                    Choice B: Go with others
                    </MDBCardText>
                </MDBCardBody>
                </MDBCard>
                </MDBCol>
            </MDBRow>
            <MDBRow>
                <MDBCol>
                <MDBCard className="mt-5"> 
                <MDBCardBody>
                    <MDBCardTitle className="">Scene 6: Exit Scene</MDBCardTitle>
                    <canvas id="scene6">

                    </canvas>
                    <MDBCardText>
                    Narrator: You went outside the classroom and saw two exits should you
                    </MDBCardText>
                    <MDBCardText>
                    Choice A: Go down the stairs
                    </MDBCardText>
                    <MDBCardText>
                    Choice B: Go inside the elevator
                    </MDBCardText>
                </MDBCardBody>
                </MDBCard>
                </MDBCol>
            </MDBRow>
            </MDBContainer>
             
        </MDBContainer>
    )
}

export default Earthquake;